import styled from 'styled-components'

import mortgageReferralsImg from 'app/assets/icons/mortgage-referrals.png'
import { Box, Button, Flex } from 'app/components/design-system-components'
import { mediaQueries } from 'app/components/design-system-components/styles/variables'
import theme from 'app/match/applicationReportPDF/assets/theme'
import {
  GTM_MORTGAGE_APPLICATION_CTA_BUTTON,
  GTM_MORTGAGE_DASHBOARD_LEARN_MORE_LINK,
} from 'app/utils/google-tag-manager/helpers'

const StyledFlex = styled(Flex)`
  line-height: 140%;
  color: ${theme.colors.gray800};
  .text {
    width: 70%;
    margin-right: ${theme.space[3]}px;
  }
  .image {
    width: ${theme.width[31]}px;
  }
  ${mediaQueries.sm} {
    flex-direction: column;
    width: 100%;
    text-align: center;
    .text {
      width: 100%;
    }
    .image {
      width: 100%;
      margin-top: ${theme.space[5]}px;
    }
  }
`

const RENTVEST_URL = 'https://get.snug.com/rentvest/'

function MortgageBanner() {
  return (
    <StyledFlex
      alignItems="center"
      p={5}
      justifyContent="space-between"
      width="100%"
    >
      <Box className="text">
        <img src={mortgageReferralsImg} alt="mortgage logo" height="75px" />
        <Box mt={4}>
          Build your wealth through property. Unlock exclusive discounts.{' '}
          <Button
            variant="linkBlue"
            className={GTM_MORTGAGE_DASHBOARD_LEARN_MORE_LINK}
            onClick={() => window.open(RENTVEST_URL, '_blank')}
          >
            learn more
          </Button>
        </Box>
      </Box>
      <Box className="image">
        <Button
          p={4}
          sizeVariant="large"
          width="100%"
          onClick={() => window.open(RENTVEST_URL, '_blank')}
          className={GTM_MORTGAGE_APPLICATION_CTA_BUTTON}
        >
          Find out more
        </Button>
      </Box>
    </StyledFlex>
  )
}

export default MortgageBanner
